import { ServerClient } from 'common/utils/http/http-clients';
import { IRejectRentalProperty, IRentalPropertyDetailsRead, IRentalPropertyRead } from './rental-property.service.types';

class RentalPropertyService {
  async getRentalProperties(): Promise<IRentalPropertyRead[]> {
    const res = await ServerClient.get<IRentalPropertyRead[]>('/rental-properties');
    return res?.data;
  }

  async getRentalProperty(rentalPropertyId: number): Promise<IRentalPropertyDetailsRead> {
    const res = await ServerClient.get<IRentalPropertyDetailsRead>(`/rental-properties/${rentalPropertyId}`);
    return res?.data;
  }

  async approve(rentalPropertyId: number): Promise<void> {
    await ServerClient.post(`/rental-properties/${rentalPropertyId}/actions/approve`);
  }

  async reject(rentalPropertyId: number, model: IRejectRentalProperty): Promise<void> {
    await ServerClient.post(`/rental-properties/${rentalPropertyId}/actions/reject`, model);
  }
}

export const rentalPropertyService = new RentalPropertyService();
export default rentalPropertyService;
